export default {
  route: {
    dashboard: '首页',
    guideInventory: '库存查看',
    hotelInventory: '酒店价格&库存管理',
    garden2: '皇家花园2卧价格管理',
    garden3: '皇家花园3卧价格管理',
    housePrice: '中国城钟点房价格管理',
    hotelhourprice24: '皇家花园2卧24小时房',
    fleet: '车队库存管理',
    fleetInventory: '车队库存',
    hotelOrders: '酒店订单',
    online_order: '线上订单',
    SPAorders: 'SPA订单',
    rangeOrders: '靶场订单',
    fleetorders: '车队订单',
    fullOrder: '全部订单',
    hotelFullOrder: '酒店全部订单',
    spaFullOrder: 'SPA全部订单',
    clubFullOrder: '靶场全部订单',
    carFullOrder: '车队全部订单',
    virtualOrders: '虚拟订单',
    Offlinevalidorder: '线下有效订单',
    Invalid_orders: '线下无效订单',
    tobeuser_orders: '线下待到店',
    over_orders: '线下已完成',
    offline_audit_order: '线下待审核订单',
    offline_to_stay_in: '线下待入住订单',
    offlineOrder: '线下订单列表',
    offlineOrderEntry: '线下订单录入',
    refundOrder: '退款订单',
    hotelrefundOrder: '酒店退款订单',
    SPArefundOrder: 'SPA退款订单',
    clubrefundOrder: '靶场退款订单',
    carrefundOrder: '车队退款订单',
    UserManagement: '用户管理',
    administrators: '管理员',
    WriteOffUsers: '核销用户',
    SystemCustomerService: '系统客服',
    SystemManagement: '系统管理',
    SetModuleCategory: '分类管理',
    SetModule: '功能管理',
    setRole: '角色管理',
    SetPermission: '权限管理',
    profile: '个人中心',
    clubStock: '靶场库存管理',
    clubStockZhao: '总部库存管理',
    clubDaily: '靶场库存日报',
    clubDailyZhao: '总部库存日报',
    offlineOrders: '线下订单',
    clubPackage: '套餐订购日报',
    hotelStatistics: '酒店数据统计',
    hotelDayStatistics: '酒店数据按天统计',
    hotelAllDetail: '订单详情',
    inputOrder: '录入订单',
    offlineFreeorder: '线下免费订单',
    mileageList: '车辆行驶公里列表',
    damageList: '车辆损坏列表',
    maintenanceList: '车辆保养列表',
    vehicleList: '车辆列表',
    vehicleReport: '车辆数据日报表',
    VehicleUseDrawing: '车辆使用图',
    driverReport: '司机数据日报表',
    monthlyStatement: '月结算报表',
    checkStatement: '查看对账单',
    RoyalGarden: '皇家花园订单',
    OrderDaily: '订单日报',
    OrderMonthlyReport: '订单月报',
    china_town: '中国城订单',
    driver_license: '司机列表',
    message: '消息中心',
    OrderCategories: '订单分类日报',
    product: '产品管理',
    statistics: '数据统计',
    all_stats: '全部统计',
    hotel_stats: '酒店统计',
    club_stats: '靶场统计',
    car_stats: '车队统计',
    timedTaskType: '定时任务类型',
    timedTask: '定时任务'
  },
  navbar: {
    dashboard: '首页',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人中心',
    theme: '换肤',
    size: '布局大小',
    product_management: '产品管理',
    order_management: '订单管理',
    refund_management: '退单管理',
    system_management: '系统管理'
  },
  login: {
    title: 'ALP文旅集团管理系统',
    logIn: '登录',
    username: '账号',
    password: '密码',
    code: '验证码',
    nameMsg: '请输入用户名',
    nameLength: '长度在 5 到 50 个字符',
    passwordMsg: '请输入密码',
    passwordLength: '长度在 6 到 24 个字符',
    codeMsg: '请输入验证码',
    bottomInf: '版权信息：©2019 by ALP文旅集团.  All rights reserved.',
    tokenFail: 'TOKEN认证失效,请重新登录'
  },
  hotel: {
    check_in_time: '入住时间段小于当前时间',
    name_repeated: '入住人姓名重复',
    passport_number_repeated: '入住人护照号重复',
    special_text: '请输入特殊需求',
    special_requirements: '特殊需求',
    hotel1: '皇家花园2卧1房',
    hotel2: '皇家花园2卧2房',
    hotelr1: '皇家花园-1房',
    hotelr2: '皇家花园-2卧',
    hotelr3: '皇家花园-3卧',
    hotel24: '皇家花园-2卧24小时房',
    hotel3: '中国城',
    surplus: '剩余',
    reserve: '已预定',
    room: '间',
    room_tao: '套',
    DiscountPrice: '折扣价',
    newPrice: '新增价格',
    goOnline: '上线',
    offline: '下线',
    tips: '提示: 批量修改选中的日期',
    Price: '价格',
    salesPrice: '销售价:',
    discountPrice: '折扣价:',
    hourPrice: '小时销售价:',
    hourDiscount: '小时折扣价:',
    immediatesubmission: '立即提交',
    reset: '重置',
    Hotel: '酒店',
    roomtype: '房型',
    Stock: '库存',
    Validityperiodofprice: '价格有效期',
    starttime: '请输入起始时间',
    Deadline: '请输入截止时间',
    week: '星期',
    RoyalGarden: '皇家花园',
    Chinatown: '中国城',
    Hourroom: '钟点房',
    lying2: '2卧',
    lying3: '3卧',
    Monday: '周一',
    Tuesday: '周二',
    Wednesday: '周三',
    Thursday: '周四',
    Friday: '周五',
    Saturday: '周六',
    Sunday: '周日',
    cancel: '取 消',
    Determine: '确 定',
    SalesPrice: '请输入销售价',
    Discountprice: '请输入折扣价',
    chooseDate: '请选择日期',
    enterStock: '请输入库存',
    enterNumber: '请输入数字',
    chooseone: '请至少选择一个',
    fullyBooked: '已订满',
    noSet: '未设置',
    stock_all: '剩余间数合计',
    booked_all: '已预订间数合计',
    checkedin_all: '正在入住间数合计',
    finished_all: '已入住离店间数合计',
    finished: '已入住离店',
    check_in: '正在入住',

    // 订房报告
    reservation_report: '订房报告',
    arrivals: '抵达',
    staying: '住宿中',
    departures: '退房',

    // 房间生产报告
    segment: '段',
    lodging: '住宿',
    pax: '人数',
    avrg_rmrate: '平均房价',
    MTDRoom: '本月至今房数',
    YTDRoom: '年初至今房数',

    // 客房收入报告
    service: '服务费',
    GovernmentTax: '政府税',

    day_nett: '日净利润',
    day_cros: '日毛利',

    month_nett: '月净利润',
    month_cros: '月毛利',

    year_service: '年净利润',
    year_cros: '年毛利'
  },
  fleet: {
    GeneratingInventory: '生成库存',
    Vehicletype: '车型',
    seaLion: '海狮',
    serena: '塞丽娜',
    fugu: '复古车',
    Typeofoperation: '操作类型',
    increase: '增加',
    reduce: '减少',
    service_time: '服务时长',
    cost_price: '市场成本价',
    sales_price: '市场销售价',
    hours: '小时',
    noSet: '未设置',
    car: '辆'
  },
  clubStock: {
    time: '日期',
    consume: '消耗',
    sn: '订单号',
    stockStatus: '库存增/减',
    surplus: '剩余',
    total: '汇总',
    order_num: '订单数量',
    daily_rules: '统计“已完成”状态，且到店时间也在当天的订单。'
  },
  users: {
    a: '新增管理员',
    b: '新增核销用户',
    NewCustomerService: '新增客服',
    c: '编辑',
    d: '禁用',
    e: '正常',
    f: '用户名',
    g: '昵称',
    h: '密码',
    i: '邮箱',
    j: '手机号',
    k: '状态',
    i1: '权限组选择',
    picture: '图片',
    del: '删除',
    UploadCode: '上传二维码',
    SelectPictures: '选取图片',
    ff: '请输入用户名',
    gg: '请输入昵称',
    ggb: '长度在 5 到 50 个字符',
    ggc: '长度在 0 到 20 个字符',
    hh: '请输入密码',
    ii: '请输入邮箱',
    iib: '请输入正确的邮箱',
    jj: '请输入手机号',
    jjb: '11位纯数字',
    ii1: '请选择',
    l: '最后登陆时间',
    m: '创建时间',
    n: '更新时间',
    o: '操作',
    p: '获取激活码'
  },
  print: '打印',
  order: {
    actualTime: '到店时间/离店时间(实际)',
    QuickCheckInTime: '办理入住时间快速查询',
    Amountcalculationmethod: '金额计算方式',
    Oneway: '方式一 自动计算单价',
    Modetwo: '方式二 自动计算总价',
    registrationForm: '登记表',
    t_AOEO: '符合条件的订单合计总金额: ',
    sum_to: '共计',
    new_order: '您有新订单，请及时处理',
    room_type: '房间类型',
    yes: '是',
    no: '否',
    Whether_hours: '是否24小时入住',
    course_reversal: '返航',
    fall_to_the_ground: '落地',
    FLT_No_num: '请填写航班号',
    FLT_No: '航班号',
    Tobesubmitted: '待提交',
    Tobepaid: '待支付',
    confirmed: '待确认库存',
    Stayin: '待入住',
    Tobeused: '待使用',
    StayStore: '待到店',
    to_be_confirmed: '待确认',
    Completed: '已完成',
    undo: '已撤销',
    Applicationforrefund: '申请退款',
    Toberefunded: '待退款',
    HasRefunded: '已退款',
    have_expired: '已过期',
    refused: '已拒绝',
    Partialrefund: '部分退款',
    Failuretopay: '支付失败',
    Failureofrefund: '退款失败',
    Refundauditfailed: '退款审核失败',
    Paymentoverdue: '支付过期',
    Cancellationoforder: '取消订单',
    Wechat: '微信公众号',
    applet: '微信小程序',
    Computer: '电脑端',
    Otherchannels: '其它渠道',
    Startingorder: '下单时间开始',
    Deadlineorders: '下单时间截止',
    DepartureBegins: '离店时间开始',
    Departuredeadline: '离店时间截止',
    ApplicationBegins: '申请日期开始',
    Applicationdeadline: '申请日期截止',
    AuditBegins: '审核日期开始',
    Auditdeadline: '审核日期截止',
    operation: '操作',
    cancelled: '已取消',
    cancel: '取消',
    save: '保存',
    preserving: '保存中',
    details: '查看详情',
    information: '基本信息',
    order_sn: '订单编号',
    refund_sn: '退款单号',
    client_type: '订单来源',
    created: '下单时间',
    order_status: '订单状态',
    order: '订单',
    cancel_desc: '变更政策',
    remark: '备注',
    special_remark: '特殊需求',
    refund: '退款',
    reservation_information: '预定信息',
    order_amount: '订单金额',
    product_price: '单价',
    product: '预定服务',
    service_name: '预定服务',
    product_num: '预定数量',
    people_num: '人数',
    start_time: '到店时间',
    selectOrder: '请选择订单来源',
    HotelType: '酒店房型',
    selectDate: '选择日期',
    SelectionTimePeriod: '选择时间段',
    Starttime: '开始时间',
    Endtime: '结束时间',
    choosetime: '请选择开始时间',
    CheckOutDate: '退房时间',
    ChooseADte: '选择日期',
    Quantity: '数量',
    Currency: '币种',
    PaymentAmount: '支付金额',
    ResidentInformation: '入住人信息',
    Room: '房间',
    NameOccupant: '入住人姓名',
    PassportNumber: '护照号',
    RoomNumber: '房间号',
    yourName: '请填写姓名',
    yourPassportNumber: '请填写护照号',
    roomnumber: '请填写房间号',
    Stayinstructions: '入住说明',
    checkinstructions: '请输入入住说明',
    addcheck_in: '添加入住说明',
    Createitnow: '立即创建',
    Cancel: '取消',
    CancelOrder: '取消订单',
    ExamineOrder: '审核订单',
    ConfirmArrival: '确认到店',
    AreYouSureConfirmArrival: '是否确认到店',
    cannotConfirmArrival: '未在规定日期办理入住。',
    CheckOut: '离店退房',
    AreYouSureCheckOut: '是否确认离店退房',
    ConfirmClub: '核销',
    AreYouSureConfirmClub: '是否确认核销订单',
    AreYouSureConfirmCancel: '是否确认取消',
    ChinatownHourHouse: '中国城-钟点房',
    Undertheline: '线下',
    ailvpai: '爱旅拍',
    lvxingshe: '旅行社',
    shibeikeji: '拾贝科技',
    shanshuidichan: '山水地产',
    Other: '其他',
    RMB: '人民币',
    Rupiah: '印尼盾',
    usd: '美 金',
    namecannot: '入住人姓名不能为空',
    Passportempty: '护照号不能为空',
    Roomempty: '房间号不能为空',
    Successful: '创建订单成功',
    EnterOrderNumber: '输入订单编号',
    Inputrefundnumber: '输入退款编号',
    HotelName: '酒店名称',
    Checkedin: '已入住',
    Enterorders: '录入订单',
    Checktimebegins: '入住时间开始',
    Checktime: '入住时间',
    Checkdeadline: '入住时间截止',
    check_in_start: '办理入住时间开始',
    check_in_end: '办理入住时间截止',
    actual_start: '实际入住时间开始',
    actual_end: '实际入住时间截止',
    hotel: {
      unit_price: '单价',
      total_money: '总金额',
      product: '酒店',
      product_model: '房型',
      service_name: '房型',
      start_time: '入住时间',
      end_time: '退房时间',
      product_num: '间数',
      tao: '套数',
      days: '天数',
      product_info: '每日价格详情(含税)',
      room: '房间',
      name: '入住人',
      tourist: '入住人',
      room_num: '房间号',
      remark: '入住说明',
      room_type_2_1: '2卧室1房别墅',
      room_type_2_2: '2卧室2房别墅',
      room_type_2_24: '2卧室24小时房',
      room_type_3: '3卧室别墅',
      room_type_hour: '钟点房',
      tip1: '入往时间早于当日12点，会多入住1晚'
    },
    car: {
      start_time: '包车时间',
      service_name: '车型',
      start_date: '包车日期',
      receiving_time: '接客时间',
      uses: '用途',
      pack_up: '收起',
      look_over: '查看'
    },
    username: '昵称',
    tourist: '客人信息',
    certificateNum: '证件号',
    id_no: '护照',
    id_no_ID: '身份证',
    id_no_passport: '护照',
    id_no_militaryID: '军官证',
    address: '接送地址',
    come_address: '接客地点',
    sent_address: '送客地点',
    refund_reasons: '退款原因',
    cancel_reasons: '取消原因',
    refund_order_reasons: '退单原因',
    examine_reasons: '审核备注',
    addremark: '添加备注',
    payment_information: '支付信息',
    paid: '支付时间',
    pay_type: '支付方式',
    pay_fee_type: '支付币种',
    pay_order_sn: '支付订单号',
    real_amount: '支付金额',
    refund_money: '退款金额',
    refunded: '申请退款日期',
    request_amount: '申请退款金额',
    approvalled: '实际退款日期',
    log: {
      title: '订单日志',
      created: '操作时间',
      username: '操作人',
      action: '操作类型',
      status: '订单状态'
    },
    refundType: '退款类型',
    refundTypeOptions: {
      Full_refund: '全额退款',
      Partial_refund: '部分退款',
      Refusal_refund: '拒绝退款'
    },
    refund_remark_null: '请输入退款原因',
    cancel_remark_null: '请输入取消原因',
    save_success: '保存成功',
    refund_success: '订单退款成功',
    cancel_success: '订单取消成功',
    tourname: '导游姓名',
    copiesNum: '份数',
    order_type: '订单类型',
    package_name: '套餐名称',
    discount_type: '折扣类型',
    chargeback: '退单'
  },
  setting: {
    add: '新增',
    addMenu: '新增菜单',
    addPer: '新增权限',
    addRole: '新增角色',
    addModuleCategory: '新增分类',
    choseMenu: '选择菜单组',
    choseParent: '选择父级功能',
    choseCategory: '选择分类',
    filter: '筛选',
    available: '可用',
    disable: '禁用',
    enable: '启用',
    operating: '操作',
    edit: '编辑',
    modify: '修改',
    please_choose: '请选择',
    please_enter: '请输入',
    clear: '清空',
    save: '保存',
    sure: '确 定',
    cancel: '取 消',
    name: '名称',
    alias: '别名',
    route: '路由',
    status: '状态',
    category_id: '分类名称',
    sort_pos: '排序',
    parent_id: '父功能名称',
    created: '创建时间',
    updated: '更新时间',
    superior_menu: '父级',
    funtion_name: '功能名称',
    lang: '多语言设置',
    rules_name: '请输入名称',
    rules_alias: '请输入别名',
    rules_alias_length: '3-50位字母、下划线组成',
    rules_sort_pos: '请输入排序(数字)',
    rules_sort_pos_number: '排序为数字',
    rules_status: '请选择默认状态',
    rules_controller: '请输入权限控制器',
    root: '根目录',
    success: '成功',
    fail: '失败',
    per_name: '权限名称',
    controller: '接口控制器',
    permission: '关联权限',
    category: '关联分类',
    effective: '重新登录后生效',
    editStock: '增加/减少库存',
    empty: '当前为空',
    tel: '联系方式',
    name_cn: '中文名称',
    name_en: '英文名称',
    name_in: '印尼名称',
    Chinese: '中文',
    English: '英文',
    Indonesia: '印尼',
    icon: '图标',
    show: '显示',
    hide: '隐藏',
    copy: '复制'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    number: '编号'
  },
  example: {
    warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  pdf: {
    tips: '这里使用   window.print() 来实现下载pdf的功能'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  clubOrders: {
    clubOrders_ddh: '订单号',
    clubOrders_ddly: '订单来源',
    clubOrders_ddlx: '销售类型',
    clubOrders_yhxm: '用户姓名',
    clubOrders_fs: '份数',
    clubOrders_rs: '人数',
    clubOrders_tcsl: '套餐数量',
    clubOrders_ddsj: '到店时间',
    clubOrders_tclx: '套餐类型',
    clubOrders_zkfs: '折扣方式',
    clubOrders_skbz: '收款币种',
    clubOrders_skfs: '收款方式',
    clubOrders_sjskje: '实际收款金额',
    clubOrders_ddzt: '订单状态',
    clubOrders_xdsj: '下单时间',
    clubOrders_rmbskje: '人民币收款金额',
    clubOrders_idrskje: '印尼盾收款金额',
    clubOrders_usdskje: '美元收款金额',
    clubOrders_lrxxdd: '录入线下订单',
    clubOrders_yx: '一销',
    clubOrders_ex: '二销',
    clubOrders_yj: '原价',
    clubOrders_bz: '8折',
    clubOrders_mf: '免费',
    clubOrders_rmb: '人民币',
    clubOrders_ynd: '印尼盾',
    clubOrders_mj: '美金',
    clubOrders_wx: '微信',
    clubOrders_zfb: '支付宝',
    clubOrders_xx: '线下',
    clubOrders_sk: '刷卡',
    clubOrders_xj: '现金',
    clubOrders_xxddlr: '录入线下订单',
    clubOrders_xzddly: '请选择订单来源',
    clubOrders_dyxm: '导游姓名',
    clubOrders_lxsmc: '旅行社名称',
    clubOrders_jsdz: '接送地址',
    clubOrders_xztc: '选择套餐',
    clubOrders_xz: '选择',
    clubOrders_tcmc: '套餐名称',
    clubOrders_zds: '子弹数',
    clubOrders_zdxh: '子弹型号',
    clubOrders_yndjg: '印尼盾价格',
    clubOrders_yndskjg: '印尼盾收款金额',
    clubOrders_srrmbskje: '请输入人民币收款金额',
    clubOrders_srmjskje: '请输入美元收款金额',
    clubOrders_beizhu: '备注',
    clubOrders_scdd: '生成订单',
    clubOrders_srdyxm: '请输入导游姓名',
    clubOrders_srlvsmc: '请输入旅行社名称',
    clubOrders_srskje: '请输入收款金额',
    clubOrders_srfs: '请输入份数',
    clubOrders_srrs: '请输入人数'
  },
  hotelAllData: {// 酒店数据统计
    hotelAllData_hj: '合计',
    hotelAllData_fjs: '房间数',
    hotelAllData_je: '金额',
    hotelAllData_drz: '待入住',
    hotelAllData_yrz: '已入住',
    hotelAllData_jrdrz: '今日待入住',
    hotelAllData_jryrz: '今日已入住',
    hotelAllData_zrdrz: '昨日待入住',
    hotelAllData_zryrz: '昨日已入住',
    hotelAllData_yzdrz: '最近一周待入住',
    hotelAllData_yzyrz: '最近一周已入住',
    hotelAllData_yydrz: '最近一个月待入住',
    hotelAllData_yyyrz: '最近一个月已入住'
  },
  carOrders: {
    is_operate_car: '是否运营车',
    driving_date: '行驶日期',
    modify_km: '修改车辆使用公里数',
    last_maintain_date: '最后保养日期',
    enter_free_orders: '录入线下免费订单',
    enter_valid_orders: '录入线下有效订单',
    order_sn: '申请单号',
    username: '用户姓名',
    company: '申请部门',
    purpose: '用途',
    package: '套餐内容',
    order_status: '订单状态',
    address: '接客地点',
    send_address: '送客地点',
    stage_time: '接客时间',
    car_brand: '车辆品牌',
    driver: '司机',
    car_license: '车牌号',
    apply_time: '申请时间',
    summary_amount: '实际收款金额汇总',
    service_time: '时长',
    original_type: '原单类型',
    real_amount_rmb: '原单金额(CNY)',
    real_amount_idr: '原单金额(IDR)',
    overtime_price_rmb: '超时金额(CNY)',
    overtime_price_idr: '超时金额(IDR)',
    overrange_price_rmb: '超范围金额(CNY)',
    overrange_price_idr: '超范围金额(IDR)',
    wait_audit: '待领导审核',
    wait_dispatch: '待调度分配',
    pass_dispatch: '调度通过',
    no_pass_audit: '领导审核不通过',
    no_pass_dispatch: '调度不通过',
    canceled: '已取消',
    leader_audit: '部门领导审核',
    dispatch_audit: '调度审核',
    cancel_apply: '取消申请',
    contact: '联系方式',
    dispatching: '调度分配',
    is_receive_guest: '司机是否准时接到客人',
    is_on_time: '是否准时接到客人',
    content: '内容',
    real_arrive_time: '实际到达时间：',
    choose_date: '选择日期时间',
    no_arrive_reason: '未准时到达原因：',
    enter_content: '请输入内容',
    arrive_on_time: '准时到达',
    not_arrive_on_time: '未准时到达',
    reason: '原因：',
    time_and_scope: '超出时长/超出范围',
    beyond_time: '超过用车时长：',
    beyond_scope: '超过用车范围：',
    beyond_price: '填写超出价格',
    yuan: '元',
    billing_info: '结算信息',
    pay_method: '结算方式',
    pay_currency: '结算币种',
    pay_amount: '应付金额',
    is_pass: '是否通过',
    leader_pass: '部门领导通过',
    leader_no_pass: '部门领导不通过',
    leader_audit_pass: '部门领导审核完成',
    complete_audit: '订单调度审核完成',
    cancel_suc: '取消成功',
    dispatch_update_suc: '调度信息更新成功',
    guest_update_suc: '客人接送信息更新成功',
    complete_dispatch_first: '请先完成调度分配',
    choose_amount: '请在套餐内选择金额',
    choose_amount_pay: '请在套餐内选择并输入支付金额',
    choose_price: '请在套餐内选择价格',
    add_suc: '添加成功',
    enter_time: '录入时间',
    all_license: '全部车牌',
    enter_mileage: '录入车辆使用公里数',
    driving_km: '行驶公里',
    choose_brand: '请选择车辆品牌',
    choose_license: '请选择车牌号',
    km: '公里',
    submit: '提交',
    enter_km: '请填写公里数',
    enter_correct_km: '请填写正确的公里数',
    enter_suc: '录入成功',
    enter_damage: '录入车辆损坏情况',
    is_repaired: '是否需要维修',
    check_damage_info: '调度查验后车辆损坏情况',
    repair_date: '维修日期',
    repair_info: '维修详情',
    damage_place_time: '车损情况，维修地点，维修时长等',
    enter_damage_info: '请输入车辆损坏情况',
    fix_suc: '修改成功',
    damage_info: '车辆损坏详情',
    maintenance_km: '保养公里',
    is_maintenance: '是否需要保养',
    maintenance_info: '车辆保养详情',
    maintenance_date: '保养日期',
    main_info: '保养详情',
    main_time_problem: '保养情况，时长，保养过程中车辆问题等',
    choose_maintenance: '请选择是否需要保养',
    accumulate_km: '累积行驶公里',
    car_status: '车辆状态',
    normal_use: '正常使用',
    improper_use: '暂停使用',
    set_normal: '置为正常',
    repair_record: '维修记录',
    maintenance_record: '保养记录',
    no_data: '暂无数据',
    main_km: '保养时公里',
    statistics: '日报统计昨天之前的数据，包括昨天',
    date: '日期',
    use_summary: '使用时长汇总',
    free_summary: '空闲时长汇总',
    time_summary: '工作时长汇总',
    choose_month: '选择月份',
    account_state: '结算状态',
    account_wait: '待结算',
    accounted: '已结算',
    month: '月份',
    account: '结算',
    check_talbe: '查看对帐表',
    account_suc: '结算成功',
    enter_price: '请输入价格',
    enter_remark: '请输入备注',
    choose_arrive_time: '请选择实际到达时间',
    choose_reason: '请填写未准时到达原因',
    driver_name: '司机姓名',
    recieve_start: '接客开始日期',
    recieve_end: '接客结束日期',
    details: '查看详情',
    enter_driver: '录入司机信息',
    edit_dirver: '修改司机信息',
    is_del: '是否要删除司机',
    tips: '提示',
    enter_driver_name: '请填写司机姓名',
    all: '全部',
    distribution: '待分配',
    using: '使用中',
    finished: '使用完毕',
    car_info: '车辆信息',
    color: '颜色',
    valid_date: '车证有效期',
    tax_date: '最后纳税日期',
    car_date: '最后车险日期',
    appearance: '外观状况',
    belong: '属于',
    vehicle_num: '车辆识别号',
    engine_num: '引擎编号',
    ownership_num: '车辆拥有证号码',
    ownership_adr: '车辆拥有证所在',
    car_adr: '车号证所在',
    capacity: '气缸容量',
    made_year: '制造年份',
    liabilities: '负债人',
    other_info: '其他信息',
    isdel_car: '是否要删除车辆'
  },
  chinaTown: {
    upload: '导入数据',
    myExportList: '导入列表',
    name: '名 称 ',
    type: '数据类型',
    choseFile: '选取文件',
    choseTip: '每次只能导入1个csv文件',
    taskName: '任务名称',
    userName: '上传人',
    created: '导入时间',
    again: '重新导入',
    paid: '交易时间',
    discount_amount: '折扣额',
    service_amount: '服务费',
    tax_amount: '税费',
    real_amount: '实际支付金额',
    consumption_data: '消费数据',
    room_data: '房间数据',
    to_be: '待执行',
    executing: '执行中',
    finish: '完成',
    failure: '失败',
    noCSV: '导入格式只能是 CSV 格式!',
    uploadSuccess: '上传成功，等待录入中...',
    user: '操作员',
    ProductInformation: '产品信息',
    product_id: '产品编号',
    product_name: '产品名称',
    product_unit: '计量单位',
    after_discount_amount: '折后金额',
    gratuity: '服务费',
    guest_name: '客人姓名',
    country: '国家',
    check_in: '到店日期',
    service_time: '入住几晚',
    is_additional: '是否加床',
    total_order_no: '订单总数',
    Today: '今天',
    Yesterday: '昨天',
    ThisWeek: '本周',
    LastWeek: '上周',
    ThisMonth: '本月',
    LastMonth: '上月',
    save_all: '保存以上修改',
    add_pro: '添加产品',
    pro_num: '产品数量至少为1 ！',
    choose_pro: '请选择产品！',
    one_pro: '请至少选择一个产品 ！',
    money_num: '订单金额跟支付金额不一致！',
    source: '来源',
    category: '品类',
    total: '总数量',
    total_number: '总份数',
    Rakeback: '返佣',
    Cashback: '返现',
    Restaurant: '餐饮',
    materiel: '物料',
    GuestRoom: '客房',
    product_type: '产品类型',
    Do_want_change_product: '是否要更改产品',
    Status_as: '状态为',
    betwn: '差额',
    save: '是否保存',
    Repeat_orders: '重复订单',
    sec_type: '二级类型',
    tip_hour: '请输入几小时',
    tip_sec_type: '请输入二级类型'
  },
  royalGarden: {
    company: '部门',
    trade: '交易',
    username: '录入人',
    enter: '录入',
    last_time: '最后编辑时间'
  },
  message: { // 消息中心
    Full_reading: '全标已读',
    is_turnring: '是否接收声音提示：',
    details: '详情'
  },
  profile: { // 个人中心
    nickname: '昵称',
    avatar: '头像',
    password: '密码',
    confirmPassword: '确认密码',
    submit: '提交',
    reset: '重置',
    defaultPage: '设置默认打开页'
  },
  // 订单共有
  allOrders: {
    btn_today: '今天',
    btn_yesterday: '昨天',
    btn_this_week: '本周',
    btn_last_week: '上周',
    btn_this_month: '本月',
    btn_last_month: '上月',
    btn_all: '全部',
    btn_select: '筛选',
    btn_details: '查看详情',
    btn_submit: '提交',
    btn_save: '保存',
    btn_modify: '保存修改',
    btn_edit: '编辑',
    btn_del: '删除',
    btn_sure: '确定',
    btn_cancel: '取消',
    btn_cancelled: '已取消',
    btn_export: '导出',
    txt_sum: '实际收款金额汇总',
    radio_yes: '是',
    radio_no: '否',
    yuan: '元',
    header_operate: '操作',
    tip_add_suc: '添加成功',
    tip_cancel_suc: '取消成功',
    tip_save_suc: '保存成功',
    tip_back_suc: '退单成功',
    tip_hexiao: '核销成功',
    tip_del: '删除成功',
    tip_tips: '提示',
    txt_rmb: '人民币',
    txt_ynd: '印尼盾',
    sel_start_date: '开始日期',
    sel_end_date: '结束日期',
    header_date: '日期',
    td_total: '汇总',
    btn_pay: '确认付款',
    start_zh: '开始',
    start_en: '',
    using: ' 使用',
    hours: '小时'
  },
  // 车队订单
  carOrder: {
    carShare: { // 车队共有
      // 筛选按钮
      sel_order_sn: '申请单号',
      sel_username: '用户姓名',
      sel_driver_name: '司机姓名',
      sel_car_number: '车牌号',
      sel_department: '申请部门',
      sel_purpose: '用途',
      sel_meal: '套餐内容',
      sel_order_state: '订单状态',
      sel_pickup_start: '接客开始日期',
      sel_pickup_end: '接客结束日期',
      sel_entry_date: '录入日期',
      sel_start_date: '开始日期',
      sel_end_date: '结束日期',
      // 表头
      header_date: '日期',
      header_car_number: '车牌号',
      header_car_brand: '车辆品牌',
      header_department: '申请部门',
      header_username: '用户姓名',
      header_pickup_address: '接客地点',
      header_pickup_time: '接客时间',
      header_purpose: '用途',
      header_length: '时长',
      header_driver: '司机',
      header_order_state: '订单状态',
      header_car_state: '车辆状态',
      header_meal: '套餐内容',
      header_original_type: '原单类型',
      header_original_amount: '订单金额',
      header_timeout_amount: '超时金额',
      header_beyond_amount: '超范围金额',
      header_apply_time: '申请时间',
      header_apply_no: '申请单号',
      // 车辆状态快速查询按钮
      txt_state_sel: '车辆状态快速查询：',
      btn_wait_distribution: '待分配',
      btn_wait_used: '待使用',
      btn_using: '使用中',
      btn_finished: '使用完毕',
      haishi: '海狮',
      sailina: '塞丽娜',
      fuguche: '复古车',
      label_car_brand: '车辆品牌',
      label_car_number: '车牌号',
      label_travel_km: '行驶公里',
      option_wait_audit: '待领导审核',
      option_wait_dispatch: '待调度分配',
      option_pass_dispatch: '调度通过',
      option_no_pass_audit: '领导审核不通过',
      option_no_pass_dispatch: '调度不通过',
      option_canceled: '已取消',
      tit_maintain: '保养录入'
    },
    enterOrder: { // 录入订单
      btn_enter_free_order: '录入线下免费订单',
      btn_enter_valid_order: '录入线下有效订单',
      label_order_source: '订单来源',
      label_username: '用户姓名',
      label_phone: '联系方式',
      label_pickup_address: '接客地点',
      label_send_address: '送客地点',
      label_pickup_time: '接客时间',
      label_purpose: '用途',
      label_car_brand: '车辆品牌',
      label_meal: '选择套餐',
      label_remark: '备注',
      tip_order_source: '请选择订单来源',
      tip_username: '请输入用户姓名',
      tip_phone: '请输入联系方式',
      tip_pickup_address: '请输入接客地点',
      tip_send_address: '请输入送客地点',
      tip_pickup_time: '请输入接客时间',
      tip_purpose: '请选择用途',
      tip_meal: '请选择套餐',
      tip_car_brand: '请选择车辆品牌',
      tip_remark: '请输入备注',
      btn_submit: '立即提交',
      btn_cacel: '取消',
      txt_see_inventory: '查看车队库存',
      txt_close_inventory: '收起车队库存',
      txt_hour: '小时',
      txt_cost_price: '市场成本价',
      txt_sales_price: '市场销售价',
      tip_noSet: '未设置',
      tip_car: '辆',
      tip_choose_amount: '请在套餐内选择金额',
      tip_choose_amount_pay: '请在套餐内选择并输入支付金额',
      tip_choose_price: '请在套餐内选择价格'
    },
    viewDetails: { // 查看详情
      title: '查看详情',
      title_basic_info: '基本信息',
      title_reserve_info: '预定信息',
      title_guest_info: '客人信息',
      title_dispatch: '调度分配',
      title_settlement_info: '结算信息',
      title_order_log: '订单日志',
      title_pickup_guest: '司机是否准时接到客人',
      title_beyond: '超出时长/超出范围',
      label_apply_no: '申请单号',
      label_order_source: '订单来源',
      label_order_time: '下单时间',
      label_remark: '备注',
      label_order_state: '订单状态',
      label_car_state: '车辆状态',
      label_operate: '操作',
      label_pickup_guest: '是否准时接到客人',
      label_real_arrive_time: '实际到达时间',
      tip_choose_date: '请选择日期时间',
      label_no_arrive_reason: '未准时到达原因',
      tip_enter_content: '请输入内容',
      txt_arrive_on_time: '准时到达',
      txt_not_arrive_on_time: '未准时到达',
      label_reason: '原因：',
      label_beyond_time: '超过用车时长',
      label_beyond_range: '超过用车范围',
      btn_leader_audit: '部门领导审核',
      btn_audit: '调度审核',
      btn_print_order: '打印订单',
      btn_cancel_apply: '取消申请',
      header_phone: '联系方式',
      header_send_address: '送客地点',
      header_remark: '备注',
      header_amount: '金额',
      header_type: '类型',
      header_settle_method: '结算方式',
      header_settle_currency: '结算币种',
      header_pay_method: '支付方式',
      header_pay_amount: '应付金额',
      header_operate_time: '操作时间',
      header_operate_name: '操作人',
      header_operate_type: '操作类型',
      header_content: '内容',
      tip_price: '填写超出价格',
      tip_amount: '支付金额',
      txt_undertheline: '线下',
      label_is_pass: '是否通过',
      radio_leader_pass: '部门领导通过',
      radio_leader_no_pass: '部门领导不通过',
      label_examine_reasons: '审核备注',
      radio_pass_dispatch: '调度通过',
      radio_no_pass_dispatch: '调度不通过',
      label_cancel_reasons: '取消原因',
      tip_cancel_reasons: '请输入取消原因',
      tip_nocar: '该套餐不含有该车辆',
      tip_leader_audit_pass: '部门领导审核完成',
      tip_complete_audit: '订单调度审核完成',
      tip_dispatch_update_suc: '调度信息更新成功',
      tip_guest_update_suc: '客人接送信息更新成功',
      tip_choose_arrive_time: '请选择实际到达时间',
      tip_choose_reason: '请填写未准时到达原因',
      tip_enter_price: '请输入价格',
      tip_complete_dispatch_first: '请先完成调度分配'
    },
    carMileage: { // 车辆行驶公里列表
      btn_enter_mileage: '录入车辆使用公里数',
      txt_title: '修改车辆使用公里数',
      label_travel_date: '行驶日期',
      tip_car_number: '请选择车牌号',
      tip_travel_km: '请输入行驶公里',
      tip_travel_date: '请选择行驶日期',
      header_travel_km: '行驶公里',
      header_travel_date: '行驶日期',
      header_enter_time: '录入时间',
      txt_km: '公里',
      tip_enter_correct_km: '请输入正确的行驶公里数'
    },
    carDamage: { // 车辆损坏列表
      btn_enter_damage: '录入车辆损坏情况',
      txt_title_info: '车辆损坏详情',
      header_enter_time: '录入日期',
      header_repair: '是否需要维修',
      label_car_info: '调度查验后车辆损坏情况',
      label_repair: '是否需要维修',
      label_repair_date: '维修日期',
      label_repair_info: '维修详情',
      tip_car_info: '请输入调度查验后车辆损坏情况',
      tip_repair_date: '请选择维修日期',
      tip_repair_info: '车损情况，维修地点，维修时长等',
      original_img: '原有图片',
      upload_img: '上传图片',
      upload_new_img: '上传新图片',
      chose_img: '选择图片',
      chose_img_tip: '只能上传jpg/png/jpeg文件',
      upload_fail: '上传失败',
      del_img: '删除图片',
      large_img: '点击图片查看大图'
    },
    carMaintenance: { // 车辆保养列表
      txt_title_detail: '车辆保养详情',
      header_km: '保养公里',
      header_maintenance: '是否需要保养',
      label_maintenance: '是否需要保养',
      label_date: '保养日期',
      label_info: '保养详情',
      tip_date: '请选择保养日期',
      tip_info: '保养情况，时长，保养过程中车辆问题等',
      tip_maintenance: '请选择是否需要保养'
    },
    cars: { // 车辆列表
      btn_enter_car: '录入车辆信息',
      txt_modify_car: '修改车辆信息',
      txt_see_detail: '查看车辆信息',
      sel_maintenance_date: '最后保养日期',
      label_operate: '是否运营车',
      label_maintenance_date: '最后保养日期',
      label_color: '颜色',
      label_valid: '车证有效期',
      label_tax_date: '最后纳税日期',
      label_insurance_date: '最后车险日期',
      label_appearance: '外观状况',
      label_belong: '属于',
      label_dentification: '车辆识别号',
      label_engine: '引擎编号',
      label_number: '车辆拥有证号码',
      label_address: '车辆拥有证所在',
      label_car_adrress: '车号证所在',
      label_cylinder: '气缸容量',
      label_made: '制造年份',
      label_indebtedness: '负债人',
      label_other: '其他信息',
      tip_car_number: '请输入车牌号',
      tip_color: '请输入颜色',
      tip_valid: '请选择车证有效期',
      tip_tax_date: '请选择最后纳税日期',
      tip_insurance_date: '请选择最后车险日期',
      tip_appearance: '请输入外观状况',
      tip_belong: '请输入属于',
      tip_dentification: '请输入车辆识别号',
      tip_engine: '请输入引擎编号',
      tip_number: '请输入车辆拥有证号码',
      tip_address: '请输入车辆拥有证所在',
      tip_car_adrress: '请输入车号证所在',
      tip_cylinder: '请输入气缸容量',
      tip_made: '请选择制造年份',
      tip_indebtedness: '请输入负债人',
      tip_other: '请输入其他信息',
      btn_normal: '置为正常',
      btn_repair: '维修记录',
      btn_maintenance: '保养记录',
      txt_no_data: '暂无数据',
      label_km: '保养时公里',
      header_travel_km: '累积行驶公里',
      header_operate: '是否运营车',
      header_valid: '车证有效期',
      header_tax_date: '最后纳税日期',
      header_insurance_date: '最后车险日期',
      header_maintenance_date: '最后保养日期',
      txt_normal_use: '正常使用',
      txt_improper_use: '暂停使用',
      txt_isdel_car: '是否要删除车辆',
      label_leijibaoyang: '累计行驶公里',
      label_shangcibaoyang: '上次实际保养公里',
      label_baoyang: '保养公里',
      label_bencibaoyang: '本次实际保养公里',
      label_shijibaoyang: '实际保养公里',
      tip_shijibaoyang: '请输入实际保养公里',
      tip_correct_shijibaoyang: '请输入正确的实际保养公里',
      wait_maintain: '待保养车辆',
      wait_use: '暂停使用车辆',
      after_maintain: '保养后公里'
    },
    drivers: { // 司机列表
      btn_enter_driver: '录入司机信息',
      txt_modify: '修改司机信息',
      header_name: '司机姓名',
      header_phone: '手机号',
      label_name: '司机姓名',
      label_phone: '手机号',
      tip_name: '请输入司机姓名',
      tip_phone: '请输入手机号',
      tip_is_del: '是否要删除司机'
    },
    dailyReport: {
      txt_statistics: '日报统计昨天之前的数据，包括昨天',
      td_use_summary: '使用时长汇总',
      td_free_summary: '空闲时长汇总'
    },
    carChart: { // 车辆使用图
      header_time: '时间',
      sel_day: '每日查询'
    },
    driverDaily: {
      td_time_summary: '工作时长汇总'
    },
    monthlyReport: { // 月结算报
      sel_month: '选择月份',
      sel_settle: '结算状态',
      option_account_wait: '待结算',
      option_accounted: '已结算',
      header_month: '月份',
      header_settle: '结算状态',
      btn_settle: '结算',
      btn_detail: '查看对账表',
      txt_settle: '结算成功',
      td_total: '汇总'
    }
  },
  // 皇家花园
  royalGardens: {
    // 全部订单
    orders: {
      sel_order_type: '订单类型',
      sel_department: '部门',
      sel_start_date: '交易开始时间',
      sel_end_date: '交易结束时间',
      header_department: '部门',
      header_order_type: '订单类型',
      header_enter_time: '录入时间',
      header_currency: '币种',
      header_amount: '金额',
      header_transaction_time: '交易时间',
      header_entry_person: '录入人',
      header_edit_time: '最后编辑时间',
      btn_enter_order: '录入订单',
      txt_edit_order: '编辑订单'
    },
    // 录入订单
    enterOrder: {
      label_order_type: '订单类型',
      label_department: '部门',
      label_transaction_time: '交易时间',
      label_currency: '币种',
      label_amount: '金额',
      label_remark: '备注',
      tip_order_type: '请选择订单类型',
      tip_amount: '请输入金额',
      tip_department: '请选择部门',
      tip_transaction_time: '请选择交易时间',
      tip_remark: '请输入备注',
      tip_currency: '请选择币种'
    },
    daily: {
      header_total_order: '订单总数',
      header_idr_amount: '总金额(IDR)',
      header_order_no: '订单数量'
    }
  },
  // 靶场订单
  clubOrder: {
    clubShare: {
      sel_order_no: '订单号',
      sel_username: '用户姓名',
      sel_order_source: '订单来源',
      sel_sale_type: '销售类型',
      sel_arrival_date: '到店日期',
      sel_arrival_sdate: '到店开始日期',
      sel_arrival_edate: '到店结束日期',
      sel_meal_type: '套餐类型',
      sel_discount: '折扣方式',
      sel_cancel_sdate: '核销开始日期',
      sel_cancel_edate: '核销结束日期',
      sel_collection_currency: '收款币种',
      sel_collection_type: '收款方式',
      sel_order_state: '订单状态',
      sel_pay_method: '付款方式',
      sel_pay_state: '付款状态',
      header_order_no: '订单号',
      header_order_source: '订单来源',
      header_sale_type: '销售类型',
      header_username: '用户姓名',
      header_num: '份数',
      header_people: '人数',
      header_arrival_time: '到店时间',
      header_meal_type: '套餐类型',
      header_pay_method: '付款方式',
      header_pay_state: '付款状态',
      header_collection_currency: '收款币种',
      header_collection_type: '收款方式',
      header_collection_amount: '实际收款金额',
      header_cancel_time: '核销时间',
      header_order_state: '订单状态',
      header_order_time: '下单时间',
      option_pay_last: '后付款',
      option_pay_first: '先付款',
      option_no_pay: '未支付',
      option_paied: '已支付',
      option_stay_store: '待到店',
      option_completed: '已完成',
      option_yx: '一销',
      option_ex: '二销',
      option_yj: '原价',
      option_bz: '8折',
      option_mf: '免费',
      option_rmb: '人民币',
      option_ynd: '印尼盾',
      option_mj: '美金',
      option_wx: '微信',
      option_zfb: '支付宝',
      option_xx: '线下',
      option_sk: '刷卡',
      option_xj: '现金'
    },
    enterOrder: { // 录入订单
      btn_enter_offline: '录入线下订单',
      btn_enter_free: '录入免费渠道订单',
      txt_modify: '修改线下订单',
      txt_modify_free: '修改线下免费订单',
      label_order_source: '订单来源',
      label_sale_type: '销售类型',
      label_guide: '导游姓名',
      label_travel: '旅行社名称',
      label_username: '用户姓名',
      label_num: '份数',
      label_people: '人数',
      label_address: '接送地址',
      label_arrival_time: '到店时间',
      label_choose_meal: '选择套餐',
      label_discount: '折扣方式',
      label_collection_type: '收款方式',
      label_pay_method: '付款方式',
      label_remark: '备注',
      label_bullet: '选择子弹',
      tip_order_source: '请选择订单来源',
      option_free: '免费',
      header_choose: '选择',
      header_num: '数量',
      header_meal_name: '套餐名称',
      header_bullets: '子弹数量',
      header_bullets_type: '子弹型号',
      header_bullets_stock: '子弹库存',
      header_price: '印尼盾价格',
      header_bullets_name: '子弹名称',
      tip_idr_price: '请输入印尼盾收款金额',
      tip_rmb_price: '请输入人民币收款金额',
      tip_doller_price: '请输入美元收款金额',
      radio_pay_last: '后付款',
      tip_username: '请输入用户姓名',
      tip_guide: '请输入导游姓名',
      tip_travel: '请输入旅行社名称',
      tip_address: '请输入接送地址',
      tip_receive_price: '请输入收款金额',
      tip_correct_format: '请输入正确的格式',
      tip_correct_amount: '请输入正确的金额',
      tip_num: '请输入份数',
      tip_people: '请输入人数',
      tip_bullet_num: '请输入子弹数量',
      tip_correct_bullet: '请输入有效的子弹数量',
      tip_bullet_one: '请至少选择一项子弹套餐',
      tip_one: '请至少选择一项'
    },
    viewDetails: { // 查看详情
      title_pay_info: '付款信息',
      title_paied_info: '支付信息',
      label_order_no: '订单编号',
      label_order_type: '订单类型',
      btn_cancel_order: '取消订单',
      btn_back_order: '退单',
      btn_verification: '核销',
      btn_modify_order: '修改订单',
      header_price: '单价',
      txt_empty: '当前为空',
      btn_choose_meal: '选择套餐',
      header_pickup_address: '接送地址',
      header_pay_time: '支付时间',
      header_pay_method: '支付方式',
      header_pay_currency: '支付币种',
      header_pay_order: '支付订单号',
      header_pay_amount: '支付金额',
      header_remark: '备注',
      txt_confirm_cancel: '是否确认取消',
      txt_refund_reasons: '退单原因',
      tip_refund_reasons: '请输入退单原因',
      txt_confirm_club: '是否确认核销订单',
      txt_id_no: '护照'
    },
    daily: {
      daily_rules: '统计“已完成”状态，且到店时间也在当天的订单。',
      header_order_num: '订单数量',
      header_meal_num: '套餐数量',
      header_rmb_amount: '人民币收款金额',
      header_idr_amount: '印尼盾收款金额',
      header_us_amount: '美元收款金额',
      header_amount: '收款金额'
    },
    enterPackage: { // 录入靶场套餐
      title: '录入靶场套餐',
      h_sale_price: '售价',
      h_dis_price: '折扣价',
      h_type_price: '价格类型',
      h_is_more: '多个产品',
      h_is_head: '是否总部套餐',
      h_package: '套餐',
      h_product: '产品',
      h_bullet_name: '产品名称',
      h_is_reduce: '是否扣库存',
      h_description: '说明',
      is_del: '是否要禁用套餐',
      radio_head: '总部',
      radio_normal: '普通',
      tip_bullet_type: '请选择子弹型号',
      tip_complete: '请把套餐信息填写完整',
      tip_sale: '请输入售价',
      tip_dis: '请输入折扣价',
      tip_name: '请输入套餐名称',
      tip_price: '请选择价格类型',
      tip_head: '请选择是否总部套餐',
      tip_more: '请选择是否多套餐',
      disable_suc: '禁用成功',
      tip_product_name: '请填写产品名称',
      tip_bullet_num: '请填写子弹数量'
    }
  },
  // 数据统计
  dataStats: {
    tit_income: '收入统计',
    tit_income_hotel: '酒店总收入',
    tit_income_club: '靶场总收入',
    tit_income_car: '车队总收入',
    tit_income_town: '中国城总收入',
    tit_income_garden: '皇家花园总收入',
    income_percent: '各业务收入占比',
    unit: '单位',
    income_month: '月收入统计',
    btn_export: '导出',
    tit_income_30: '最近30天总收入统计',
    txt_rmb: '人民币',
    txt_ynd: '印尼盾',
    total: '总收入',
    business_income: '业务收入',
    income: '收入',
    car_channel_income: '车队各渠道收入统计',
    car_income_month: '车队收入月份统计',
    car_income_30: '车队最近30天收入统计',
    order_stats: '订单统计',
    car_channel_order: '车队各渠道订单统计',
    car_order_month: '车队订单月份统计',
    car_order_30: '车队最近30天订单量统计',
    operate_stats: '运营数据统计',
    car_model: '使用车型统计',
    car_use: '车辆用途统计',
    channel: '渠道',
    order_total: '总订单量',
    order: '单',
    order_num: '订单量',
    car_use_total: '总使用车辆',
    car: '辆',
    models: '车型',
    use: '用途',
    club_channel_income: '靶场各渠道收入统计',
    channel_order: '各渠道订单统计',
    package_sale: '各套餐销量统计',
    club_order_month: '靶场月订单量统计',
    order_30: '最近30天总订单统计',
    club_order_type: '靶场订单销售类型统计',
    bullet_stats: '最近30天子弹消耗量统计',
    total_sales: '总销量',
    fen: '份',
    total_order: '总单数',
    sale_type: '销售类型',
    hotel_channel_income: '酒店各渠道收入统计',
    hotel_income_month: '酒店月收入统计',
    hotel_income_30: '酒店最近30天收入统计',
    hotel_channel_order: '酒店各渠道订单统计',
    hotel_order_month: '酒店订单月份统计',
    hotel_order_30: '酒店最近30天订单量统计',
    hotel_room_month: '酒店入住房间数月份统计',
    hotel_room_30: '酒店最近30天入住房间数统计',
    hotel_channel_room: '各渠道入住房间数月份统计',
    hotel_channel_room_30: '最近30天各渠道入住房间数统计',
    stats: '统计',
    room_num: '房间数',
    china_channel_income: '中国城各渠道收入统计',
    china_income_month: '中国城月收入统计',
    china_income_30: '中国城最近30天收入统计',
    lobby_channel_income: 'Lobby各渠道收入统计',
    lobby_income_month: 'Lobby月收入统计',
    lobby_income_30: 'Lobby最近30天收入统计'
  }
}
